// New API call to fetch all approval requests (not filtered by lead)
import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

let allRequestsAbortController: AbortController | null = null;

export interface ApprovalRequestQueryParams {
  limit?: number;
  skip?: number;
  status?: string; // optional status filter
  type?: string; // optional type filter
  lead?: string; // optional lead filter
}

export const getAllApprovalRequests = async ({
  limit = 10,
  skip = 0,
  status,
  type,
  lead,
}: ApprovalRequestQueryParams): Promise<any> => {
  // Abort any in-flight request
  if (allRequestsAbortController) {
    allRequestsAbortController.abort();
  }
  allRequestsAbortController = new AbortController();
  try {
    const url = new URL(`${config.baseURL}/api/approval-request`);
    url.searchParams.set("limit", String(limit));
    url.searchParams.set("skip", String(skip));
  if (status) url.searchParams.set("status", status);
  if (type) url.searchParams.set("type", type);
  if (lead) url.searchParams.set("lead", lead);

    // Debug logs to mirror tasks API utility
    if (status || type || lead) {
      console.log("Approval Requests - Filters:", { status, type, lead });
    }
    console.log("Approval Requests - Final API URL:", url.toString());

    const response = await AUTH_GET(url.toString(), {
      revalidate: 60,
      tags: [
        "approval-requests",
        "requests",
        `${url.searchParams.toString()}`,
        lead ? `${lead}-requests` : undefined,
      ].filter(Boolean) as string[],
      signal: allRequestsAbortController.signal,
    });
    allRequestsAbortController = null;
    return response; // expected to be { data: [], total: number }
  } catch (error: any) {
    if (error.name === "AbortError") {
      // Let callers handle abort as a rejected promise to avoid UI flicker
      console.log("Approval Requests - Fetch request canceled");
      throw error;
    }
    throw error;
  }
};
